"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepEqual = void 0;
var deepEqual_1 = require("@jsonjoy.com/json-equal/lib/deepEqual");
/**
 * @deprecated Use deepEqual from '@jsonjoy.com/json-equal/lib/deepEqual' instead.
 */
Object.defineProperty(exports, "deepEqual", { enumerable: true, get: function () { return deepEqual_1.deepEqual; } });
